module.exports = __webpack_public_path__ + "static/media/check-animation.e3af7a68.gif";